export default __webpack_public_path__ + "static/media/ashby.b5ab59a7.png";